import {GetStaticPaths, GetStaticProps} from "next";
import {serverSideTranslations} from "next-i18next/serverSideTranslations";
import FooterAppyShop from "../../components/footer/footerAppyShop";
import HeaderAppyShop, {getComponentStaticProps, HeaderProps} from "../../components/header/headerAppyShop";
import {ShopState} from "../../interfaces/store-interfaces";
import {connect} from 'react-redux'
import {getAllProductSlugs, getSingleProduct} from '../../services/product-services';
import {SingleProduct} from '../../interfaces/product-interface';
import styles from './product.module.scss';
import Price from '../../components/price/price'
import React, {useState, useEffect} from "react";
import {useTranslation} from "next-i18next";
import Link from 'next/link';
import {addToCart} from "../../store/action";
import Meta from "../../components/meta/meta";
import ImageViewer from 'react-simple-image-viewer';
import ImageGallery from 'react-image-gallery';
import ModalShop from '../../components/modal/modal'
import {useRouter} from 'next/router';
import {Modal} from "../../interfaces/utils-interfaces";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import {appyShopConfig} from "../../config";
import {Stars} from "../../components/review/stars";
import {format} from "date-fns";
import {config} from '../../config-merchant';
import ProductDetails from "../../components/custom/productDetails";

function Product(props: { headerProps: HeaderProps, currentCurrency: string, product: SingleProduct, addToCart: any, shoppingCart: {} }) {

    const router = useRouter();
    const {t} = useTranslation('common')
    const [productQuantity, setProductQuantity] = useState<number>(1);
    const [isImgViewerOpen, setImgViewer] = useState<boolean>(false);
    const [ImageGalleryRef, setImageGalleryRef] = useState(null);
    const [SlickerRef, setSlickerRef] = useState(null);
    const [isPopupOpen, setPopup] = useState<boolean>(false);
    const [widthScreen, setWidthScreen] = useState<number>(typeof window !== 'undefined' ? window.innerWidth : 1024);
    const [nbWhereDisplayArrow, setNbWhereDisplayArrow] = useState<number>(7);
    const [nbSimilarProducts] = useState<number>(!router.isFallback ? props.product.similarProducts.length : 0);
    const [imagesViewer, setImagesViewer] = useState([]);
    const [reviewsToShow, setReviewsToShow] = useState<number>(2);

    typeof window !== 'undefined' ? window.addEventListener('resize', () => setWidthScreen(window.innerWidth)) : null;

    useEffect(() => {
        const images = [];
        !router.isFallback && props.product.images.map((image, index) =>
            images.push({
                original: props.product.bigImages[index],
                thumbnail: props.product.images.length > 1 ? image : "",
                originalClass: styles['image'],
                thumbnailClass: styles['thumbnail']
            })
        )
        setImagesViewer(images);
    }, [router])

    useEffect(() => {
        if (widthScreen > 1024)
            setNbWhereDisplayArrow(7);
        if (widthScreen > 600 && widthScreen <= 1024)
            setNbWhereDisplayArrow(4);
        if (widthScreen > 480 && widthScreen <= 600)
            setNbWhereDisplayArrow(3);
        if (widthScreen <= 480)
            setNbWhereDisplayArrow(1);
    }, [widthScreen])

    const addProductToCart = () => {
        props.addToCart({idP: props.product.productId, quantity: productQuantity})
        setPopup(true);
    }

    const goToCart = () => {
        setPopup(false);
        router.push('/cart')
    }

    const continueShopping = () => {
        setPopup(false);
        router.push('/catalog')
    }

    const quantityOnShoppingCart = (productId): number => {
        if (props.shoppingCart.hasOwnProperty(productId) && props.shoppingCart[productId]["quantity"] > 0) {
            return props.shoppingCart[productId]["quantity"];
        } else {
            return 0;
        }
    }

    const renderSlides = () =>
        props.product.similarProducts.map(product =>
            <Link href={`/product/${product.productSlug}`} key={product.productSlug}>
                <div className={styles["similar-item"]}>
                    <img src={product.mainImage} alt="product"/>
                    <p>{product.name}</p>
                </div>
            </Link>)

    const sliderSettings = {
        dots: false,
        arrow: false,
        slidesToShow: nbSimilarProducts < 5 ? nbSimilarProducts : 5,
        slidesToScroll: 1,
        infinite: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: nbSimilarProducts < 3 ? nbSimilarProducts : 3,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: nbSimilarProducts < 2 ? nbSimilarProducts : 2,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    }

    const modalText: Modal = {
        title: t('PRODUCT_THANKS'),
        subtitle: t('PRODUCT_ADD_SUCCESS'),
        question: t('PRODUCT_NEXT_ACTION'),
        button1: t('PRODUCT_SEE_CART'),
        button2: t('CART_CONTINUE_SHOPPING')
    }
    return (
        router.isFallback ? <div/> :
            <>
                <Meta
                    title={props.product.name}
                    description={props.product.description?.replace(/(<([^>]+)>)/gi, "")}
                    metaRobots={true}
                    image={props.product.bigImages[0]}
                    product={props.product}
                />
                <HeaderAppyShop headerProps={props.headerProps}/>
                {
                    isImgViewerOpen && (
                        <ImageViewer
                            src={props.product.bigImages}
                            currentIndex={ImageGalleryRef.getCurrentIndex()}
                            onClose={() => setImgViewer(false)}
                            backgroundStyle={{backgroundColor: "rgba(0,0,0,0.8)", zIndex: 5}}
                        />
                    )
                }
                <main key={props.product.productId}>
                    {isPopupOpen && <ModalShop closePopup={() => setPopup(false)} actionbutton1={goToCart}
                                               actionbutton2={continueShopping} modalText={modalText}/>}
                    <div className={styles["product-details"]}>
                        <div className={styles["layout-row"]}>

                            <div className={styles["layout-column-right"]}>
                                {/* <!--Product details--> */}
                                <div className={styles["product"]}>
                                    {/* <!--Navigation--> */}
                                    <div className={styles["product-nav"]}>
                                        <p className={styles["product-goback"]}>
                                            &lsaquo; <Link href={'/catalog'}><span>{t('NAV_CATALOG')}</span></Link>
                                            / <Link
                                            href={`/catalog?category=${props.product.category.categoryId}`}><span>{props.product.category.name}</span></Link>
                                            / <p className={styles['product-focused']}>{props.product.name}</p>
                                        </p>
                                    </div>
                                    <div className={styles["product-columns"]}>
                                        {/* <!--Product image--> */}
                                        <div className={styles["product-images"]}>
                                            <ImageGallery
                                                items={imagesViewer}
                                                infinite={false}
                                                showPlayButton={false}
                                                showFullscreenButton={false}
                                                onClick={() => setImgViewer(true)}
                                                ref={setImageGalleryRef}
                                                renderLeftNav={(onClick, disabled) =>
                                                    disabled ?
                                                        <></> :
                                                        <button
                                                            className={styles['image-gallery-left-nav']}
                                                            disabled={disabled}
                                                            onClick={onClick}>
                                                            <svg className={styles["image-gallery-svg"]}
                                                                 xmlns="http://www.w3.org/2000/svg" viewBox="6 0 12 24"
                                                                 fill="none" stroke="currentColor" strokeWidth="1"
                                                                 strokeLinecap="round" strokeLinejoin="round">
                                                                <polyline points='15 18 9 12 15 6'/>
                                                            </svg>
                                                        </button>
                                                }
                                                renderRightNav={(onClick, disabled) =>
                                                    disabled ?
                                                        <></> :
                                                        <button
                                                            className={styles['image-gallery-right-nav']}
                                                            disabled={disabled}
                                                            onClick={onClick}>
                                                            <svg className={styles["image-gallery-svg"]}
                                                                 xmlns="http://www.w3.org/2000/svg" viewBox="6 0 12 24"
                                                                 fill="none" stroke="currentColor" strokeWidth="1"
                                                                 strokeLinecap="round" strokeLinejoin="round">
                                                                <polyline points='9 18 15 12 9 6'/>
                                                            </svg>
                                                        </button>
                                                }
                                            />
                                        </div>
                                        <div className={styles["product-text"]}>
                                            <h1 className={styles["name"]}>{props.product.name}</h1>
                                            <div className={styles['twoprices']}>
                                                {
                                                    props.product.prices.find(price => price.currency === props.currentCurrency).originalAmountWithTax !== null &&
                                                    <Price key={props.currentCurrency + "-original"}
                                                           price={props.product.prices.find(price => price.currency === props.currentCurrency).originalAmountWithTax}
                                                           page={'single-product'} strike={true}/>
                                                }
                                                <Price key={props.currentCurrency}
                                                       price={props.product.prices.find(price => price.currency === props.currentCurrency).amountWithTax}
                                                       page={'single-product'}/>
                                            </div>
                                            {
                                                config.reviewEnabled && !(props.product.reviews === null || props.product.reviews.length === 0) &&
                                                <div className={styles["product-title-comment"]}
                                                     onClick={() => location.hash = "#reviews"}>
                                                    <Stars score={props.product.score}/>
                                                    <div>
                                                        <p className={styles["comment-number"]}>
                                                            {/*{*/}
                                                            {/*    (props.product.reviews === null ||*/}
                                                            {/*        props.product.reviews.length === 0) && t("PRODUCT_REVIEW_0")*/}
                                                            {/*}*/}
                                                            {
                                                                props.product.reviews.length === 1 && t("PRODUCT_REVIEW_1")
                                                            }
                                                            {
                                                                props.product.reviews.length > 1 && <>{props.product.reviews.length} {t("PRODUCT_REVIEW_MANY")}</>
                                                            }
                                                        </p>
                                                    </div>
                                                </div>
                                            }

                                            <div className={styles["tags"]}>
                                                {
                                                    props.product.tags !== null && props.product.tags.map(tag =>
                                                            <span key={tag.tagId}>
                                                        {tag.name}
                                                </span>
                                                    )
                                                }
                                            </div>

                                            <div className={styles["description"]}
                                                 dangerouslySetInnerHTML={{__html: props.product.description}}/>
                                            {
                                                props.product.variations.length > 0 &&
                                                <div className={styles["variations"]}>
                                                    <div className={styles["title"]}>{t("PRODUCT_RANGES")}</div>
                                                    {
                                                        props.product.variations.map(product =>
                                                            <Link
                                                                href={`/product/${product.productSlug}`}
                                                                scroll={false}
                                                                key={product.productSlug}>
                                                                <div
                                                                    className={`${styles['item']} ${styles['tooltip']}`}>
                                                                    <img
                                                                        src={product.mainImage}
                                                                        alt="product variation"
                                                                        className={product.productSlug === props.product.productSlug ? styles['selected'] : ''}
                                                                    />
                                                                    <span
                                                                        className={styles["tooltiptext"]}>{product.name}
                                                                    </span>
                                                                </div>
                                                            </Link>)
                                                    }
                                                </div>
                                            }
                                            <div className={styles["actions"]}>
                                                {
                                                    (props.product.quantityInStock !== null && props.product.quantityInStock > 0) &&
                                                    <div className={styles["quantity-stock"]}>
                                                        {t('PRODUCT_QTY_STOCK')} : {props.product.quantityInStock}
                                                    </div>
                                                }
                                                {props.product.availableInStock ?
                                                    <>
                                                        <div className={styles["stock"]}>
                                                            <div className={styles["stock-wrapper"]}>
                                                                {
                                                                    productQuantity === 0 ?
                                                                        <button className={styles['plusminusdisabled']}
                                                                                disabled>-</button>
                                                                        : <button className={styles["plusminus"]}
                                                                                  onClick={() => setProductQuantity(productQuantity - 1)}>-</button>
                                                                }
                                                                <input value={productQuantity} type="number" min="1"
                                                                       max="100"
                                                                       onChange={(e) => setProductQuantity(+e.target.value)}/>
                                                                <button className={styles["plusminus"]}
                                                                        onClick={() => setProductQuantity(productQuantity + 1)}>+
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div onClick={productQuantity === 0 ? null : addProductToCart}
                                                             className={productQuantity === 0 ? styles['button-disabled'] : styles['button']}>
                                                            <p>{t('PRODUCT_ADD_TO_CART')}</p>
                                                        </div>
                                                    </> :
                                                    <>
                                                        <div className={styles["stock"]}>
                                                            <div className={styles["stock-wrapper"]}>
                                                                <input type="number" defaultValue="0" disabled/>
                                                            </div>
                                                        </div>
                                                        <div className={`${styles['button']} ${styles['outofstock']}`}>
                                                            <p>{t('CATALOG_OUT_OF_STOCK')}</p></div>
                                                    </>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {
                                    quantityOnShoppingCart(props.product.productId) > 0 &&
                                    <div className={styles['allreadyoncart']}>
                                        <p>{t('PRODUCT_ALREADY_ON_CART')}</p>
                                        <p>(x{quantityOnShoppingCart(props.product.productId)})</p>
                                    </div>
                                }

                                {/* <!--Information product--> */}
                                <ProductDetails product={props.product}/>

                                {/* <!--Similar products--> */}
                                {props.product.similarProducts.length > 0 &&
                                    <div className={styles["products-similar"]}
                                         key={props.product.productId}>
                                        <p className={styles["title"]}>{t('PRODUCT_SUGGESTION')}</p>
                                        <div className={styles['slicker']}>
                                            <button
                                                className={styles['image-slicker-left-nav']}
                                                onClick={() => SlickerRef.slickPrev()}>
                                                <svg
                                                    className={nbSimilarProducts < nbWhereDisplayArrow ? styles["image-gallery-svg-disable"] : styles["image-gallery-svg"]}
                                                    xmlns="http://www.w3.org/2000/svg" viewBox="6 0 12 24" fill="none"
                                                    stroke="currentColor" strokeWidth="1" strokeLinecap="round"
                                                    strokeLinejoin="round">
                                                    <polyline points='15 18 9 12 15 6'/>
                                                </svg>
                                            </button>

                                            <Slider
                                                className={styles["images"]}
                                                {...sliderSettings}
                                                ref={setSlickerRef}>
                                                {renderSlides()}
                                            </Slider>
                                            <button
                                                className={styles['image-slicker-right-nav']}
                                                onClick={() => SlickerRef.slickNext()}>
                                                <svg
                                                    className={nbSimilarProducts < nbWhereDisplayArrow ? styles["image-gallery-svg-disable"] : styles["image-gallery-svg"]}
                                                    xmlns="http://www.w3.org/2000/svg" viewBox="6 0 12 24" fill="none"
                                                    stroke="currentColor" strokeWidth="1" strokeLinecap="round"
                                                    strokeLinejoin="round">
                                                    <polyline points='9 18 15 12 9 6'/>
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                }

                                {/* <!--Comments--> */}
                                {
                                    config.reviewEnabled && props.product.reviews !== null ? (
                                        <div className={styles["product-comments"]} id={"reviews"}>
                                            <p className={styles["title"]}>{t("PRODUCT_REVIEW_TITLE")}</p>
                                            <p className={styles["number"]}>{props.product.reviews.length} {t("PRODUCT_REVIEW_MANY")}</p>

                                            {
                                                props.product.reviews.slice(0, reviewsToShow).map((review, idx) =>
                                                    <div className={styles["comment"]} key={idx}>
                                                        <p className={styles["name"]}>{review.author}</p>
                                                        <Stars score={review.score}/>
                                                        <p className={styles["date"]}>{t("PRODUCT_REVIEW_POSTED")} {format(review.reviewDate, "dd/MM/yyyy")}</p>
                                                        <p className={styles["text"]}>{review.review}</p>
                                                        {
                                                            review.response !== null && review.response &&
                                                            <div className={styles["comment-response"]}>
                                                                <p className={styles["name"]}>{config.merchantShopName}</p>
                                                                <p className={styles["date"]}>{t("PRODUCT_REVIEW_RESPONSE")} {format(review.responseDate, "dd/MM/yyyy")}</p>
                                                                <p className={styles["text"]}>{review.response}</p>
                                                            </div>
                                                        }
                                                    </div>
                                                )
                                            }
                                            {
                                                reviewsToShow < props.product.reviews.length && <p
                                                    className={styles["see-all"]}
                                                    onClick={() => setReviewsToShow(prevState => prevState + 5)}
                                                >
                                                    {t("PRODUCT_SEE_MORE")}
                                                </p>
                                            }
                                        </div>
                                    ) : <></>
                                }
                            </div>
                        </div>
                    </div>
                </main>
                <FooterAppyShop/>
            </>
    );
}

const formatData = (data, language) => {
    const slugsOfLanguage = []
    data.map(data => slugsOfLanguage.push({params: {id: data}, locale: language}))
    return slugsOfLanguage;
}


export const getStaticPaths: GetStaticPaths = async (props: { locales: string[], defaultLocale: string }) => {
    const slugs = []
    for (let i = 0; i < props.locales.length; i++) {
        const data = await getAllProductSlugs(props.locales[i].toUpperCase());
        slugs.push(formatData(data['data'], props.locales[i]));
    }
    const paths = slugs.flat(1);
    return {
        paths,
        fallback: true
    }
}

export const getStaticProps: GetStaticProps = async (props: { locale: string, params: { id: string } }) => {
    let product: SingleProduct;
    try {
        product = await getSingleProduct(props.locale.toUpperCase(), props.params.id);
        product = product['data'];
    } catch (e) {
        return {
            notFound: true,
        }
    }
    return {
        props: {
            ...await serverSideTranslations(props.locale, ['common']),
            headerProps: await getComponentStaticProps(props.locale),
            product
        },
        revalidate: appyShopConfig.revalidateData
    };
}


const mapState = (state: ShopState) => ({
    currentCurrency: state.currentCurrency,
    shoppingCart: state.shoppingCart
})

const mapDispatch = (dispatch) => {
    return {
        addToCart: (product: { idP: number, quantity: number }) => dispatch(addToCart(product))
    }
}

export default connect(mapState, mapDispatch)(Product)
